import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-identities',
  templateUrl: './help-identities.component.html',
  styleUrls: ['./help-identities.component.scss']
})
export class HelpIdentitiesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
